import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const ProtectedRoute = ({ children }) => {
  const sessionCookie = Cookies.get('session');

  // If the session cookie does not exist, redirect to the password check page
  if (!sessionCookie) {
    return <Navigate to="/" />;
  }

  return children; // Render the children if the session exists
};

export default ProtectedRoute;
